export const buttonScale = 1.1;
export const labelScale = 1 / buttonScale;